import React from 'react';

import CartSpecialOfferEntry from './CartSpecialOfferEntry';
import CartSpecialOfferDisplay from "./CartSpecialOfferDisplay";
import HiddenContentWrapper from "../../../Common/components/HiddenContentWrapper";

export default function CartCouponTool({
  shoppingCart, callbacks, checkoutConfig, ...props
}) {
  const couponConfig = checkoutConfig?.coupons || {};
  const { disabled=false, activatePrompt } = couponConfig;

  // return empty div so layout is happy
  if (disabled)
    return <div></div>;

  const {specialOffer} = shoppingCart;

  function handleRemoveCoupon(_evt) {
    callbacks.updateCart({couponCode: ""});
  }

  if (specialOffer) {
    return <CartSpecialOfferDisplay
      handleRemoveCoupon={handleRemoveCoupon}
      offer={specialOffer}/>
  }

  if (activatePrompt) {
    let caption = (activatePrompt === true) ? "Add a Coupon Code" : activatePrompt;

    let prompt = () => (<div className="cursor-pointer text-sm">
      <span className="fa fa-plus mr-1"/>
      {caption}
    </div>)

    return <HiddenContentWrapper
      captionClassName=""
      renderPrompt={prompt}>
      <CartSpecialOfferEntry
        shoppingCart={shoppingCart}
        callbacks={callbacks}
        {...props} />
    </HiddenContentWrapper>
  }

  return <CartSpecialOfferEntry
    shoppingCart={shoppingCart}
    callbacks={callbacks}
    {...props} />

}
